import { Box, HStack } from "components/ui";
import { H1 } from "components/ui/Typography";
import React, { ReactNode } from "react";
import { useIsMobile } from "utils/hooks/useIsMobile";
import Breadcrumbs from "../Breadcrumbs";
import CollapsibleText from "../CollapsibleText";

type Props = {
	title: ReactNode;
	description?: string | null;
	component?: ReactNode;
	idReplacement?: string;
};

const PageHeader = (props: Props) => {
	const { title, description, component,idReplacement } = props;
	const isMobile = useIsMobile();
	return (
		<Box
			sx={{
				paddingHorizontal: 16,
				"@md": {
					paddingHorizontal: 48,
				},
			}}
			paddingTop={32}
			paddingBottom={isMobile ? 0 : 32}
		>
			<Box pb={20}>
				<Breadcrumbs idReplacement={idReplacement} />
			</Box>
			<HStack justifyContent="space-between" alignItems="center">
				<Box flex={1}>
					{typeof title === "string" ? (
						<H1
							sx={{
								paddingBottom: 16,
								"@md": {
									paddingBottom: 20,
									lineHeight: 48,
								},
							}}
						>
							{title}
						</H1>
					) : (
						<Box
							sx={{
								paddingBottom: 16,
								"@md": {
									paddingBottom: 20,
								},
							}}
						>
							{title}
						</Box>
					)}
					{description ? <CollapsibleText text={description} /> : null}
				</Box>
				{component && <Box flex={1}>{component}</Box>}
			</HStack>
		</Box>
	);
};

export default PageHeader;
